import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ConvertIcon } from "../../icons";

const CustomImgPreviewModal = (props) => {
  const { imgSrc, show, onHide } = props;
  const [rotation, setRotation] = useState(0);
  const rotateClockwise = () => {
    if (rotation === 270) {
      setRotation(0);
    } else {
      setRotation((prev) => prev + 90);
    }
  };

  useEffect(() => {
    if (show === true) {
      setRotation(0);
    }
  }, [show]);

  return (
    <>
      <div
        onClick={onHide}
        className={`lms_preview_img_modal_bg ${
          show && "lms_preview_img_modal_open"
        }`}
      ></div>
      <div
        className={`lms_preview_img_modal d-flex ${
          show && "lms_preview_img_modal_open"
        }`}
      >
        <img
          src={imgSrc}
          alt="table img"
          style={
            rotation === 90 || rotation === 270
              ? { transform: `rotate(${rotation}deg)`, maxHeight: "65vh" }
              : { transform: `rotate(${rotation}deg)` }
          }
        />
      </div>
      <div
        className={`lms_preview_img_modal d-flex position-fixed ${
          show && "lms_preview_img_modal_open"
        }`}
        style={{ top: "50px", right: "10px", left: "unset" }}
      >
        <Button
          className="lms_preview_rotate_btn"
          onClick={() => rotateClockwise("")}
        >
          {ConvertIcon}
        </Button>
      </div>
    </>
  );
};

export default CustomImgPreviewModal;
